import type { WebsiteHeaderPhotoSchema_VideoBackground } from '@shared/types/WebsiteHeaderSettings.types';

export const VIDEO_BACKGROUND_DEFAULT: WebsiteHeaderPhotoSchema_VideoBackground = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackground-v1_1_1.json',
  presentationLayout: 'videoBackground',
  video: undefined,
  eventName: undefined,
  colors: undefined,
};
